import { Component, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { LoaderService } from './services/loader-service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App  implements  OnInit{
  protected readonly title = signal('polymarket-admin');
  ngOnInit(): void {
  initFlowbite();
  }
  constructor(public loaderService: LoaderService){}
  
}